import React from 'react';
import _ from 'lodash';

import CellContent from './CellContent';
import { Dropdown } from '../../dropdowns/portal';
import FieldTreeService from '../../../services/FieldTrees';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import { getErrorValidateWithId, handleResetFieldTreeWorks } from '../../../utilities/works';

const fieldId = SessionStorageService.getFieldId();

const ForemanTemplate = ({ grid, context, msgValidate, handlePushParam, column }) => {
  const {
    id,
    field_tree_id,
    job_id,
    work_date,
    foreman_user_id,
    foreman_user_name,
    isAbortedOrApproved,
  } = context.item;

  const handleSetData = ({ user_id, user_name }) => {
    const v = grid.collectionView;
    v.editItem(v.currentItem);
    v.currentItem['foreman_user_id'] = user_id;
    v.currentItem['foreman_user_name'] = user_name;
    if (!v.currentItem['is_data_changed']['foreman_user_id']) {
      v.currentItem['is_data_changed']['foreman_user_id'] = true;
    }
    v.commitEdit();
    handlePushParam(context.item, 'foreman_user_id');
  };

  const getError = () => {
    return getErrorValidateWithId(msgValidate, context.item, 'foreman_user_id');
  };

  const getForemanUsers = async params => {
    if (!job_id) {
      return null;
    }
    try {
      return await FieldTreeService.treeUsers(
        fieldId,
        field_tree_id,
        {
          ...params,
          date_to: work_date,
          field_id: fieldId,
          job_id,
        },
        false
      );
    } catch (error) {
      handleResetFieldTreeWorks(grid, handlePushParam, context, error);
      return null;
    }
  };

  const renderDropdownForemanUser = () => {
    return (
      <Dropdown
        handleOnChange={handleSetData}
        name={foreman_user_name}
        value={foreman_user_id}
        listForceReload={[work_date, field_tree_id, job_id].toString()}
        callbackApi={getForemanUsers}
        fieldValue='user_id'
        fieldName='user_name'
        responseNestedKey='field_tree_user'
        key={id}
        label='職長を選択'
        isShowToolTip={true}
      >
        <Dropdown.Select readOnly={isAbortedOrApproved} />
        <Dropdown.List>
          <Dropdown.Search />
          <Dropdown.RadioItems />
        </Dropdown.List>
      </Dropdown>
    );
  };

  return (
    <React.Fragment>
      <CellContent
        errorMsg={getError()}
        isDataChanged={_.get(context, 'item.is_data_changed.foreman_user_id')}
        errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
          context,
          'row.index'
        )}`}
        key={`${column}_${_.get(context, 'item.id')}`}
      >
        {renderDropdownForemanUser()}
      </CellContent>
    </React.Fragment>
  );
};

export default ForemanTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/ForemanTemplate.jsx